module.exports = {
  "page": "page",
  "pages": "pages",
  "created_by": "Created by",
  "created_on": "Created on",
  "last_updated": "Last updated",
  "untitled": "Untitled",
  "avg_time": "Avg Time",
  "downloads": "Downloads",
  "author": "Author",
  "reshares": "reshares",
  "user": "User",
  "users": "Users",
  "open_rate": "Open Rate",
  "click_rate": "Click Rate",
  "time_spent": "Time Spent",
  "shared_by": "Shared By",
  "share": "Share",
  "shares": " Shares",
  "added": "Added",
  "created": "Created",
  "recipients": "Recipients",
  "last_active": "Last active",
  "searches": "Searches",
  "role": "Role",
  "success": "Success",
  "search_placeholder": "Type here to search",
  "updated_on": "Updated on",
  "folder": "folder",
  "folders": "folders",
  "last_update": "Last update",
  "view": "View",
  "views": "Views",
  "day": "Day",
  "days": "Days",
  "or": "or",
  "others": "others",
  "last_viewed": "Last viewed",
  "owner": "Owner",
  "internal_use_only": "Internal Use Only",
  "moved": "moved",
  "deleted": "deleted",
  "contacts": "contacts",
  "contact_list": "Contact List",
  "no_activity": "No activity recorded",
  "more": "more",
  "and": "and",
  "reshare": "Reshare",
  "no_results": "No results found",
  "signed": "Signed",
  "on": "on",
  "load_more_items": "Load more items",
  "contact": "Contact",
  "company": "Company",
  "user_group": "User Group",
  "asset_actions": "Select a Stream or a Group below to {action} what you've selected",
  "map_files": "Map your files from {source} to {destination}",
  "email": "Email",
  "last_viewed_on": "Last viewed on",
  "last_downloaded_on": "Last downloaded on",
  "not_viewed": "Not yet viewed",
  "not_downloaded": "Not yet downloaded",
  "opened_email_last_on": "Opened email last on",
  "turn_on": "turn ON",
  "turn_off": "turn OFF",
  "oops_error": "Oops Error!",
  "no_details": "No Details",
  "no_contacts": "No Contacts",
  "link": "Link",
  "dnd": "DND",
  "lead": "Lead",
  "copied": "Copied",
  "error": "Error",
  "continue": "Continue",
  "yes": "Yes",
  "no": "No",
  "load_more": "Load more",
  "no_assets_found": "No assets found",
  "no_assets": "No assets",
  "activated": "activated",
  "deactivated": "deactivated",
  "added_on": "Added on",
  "crop": "Crop",
  "expired": "Expired",
  "expiring": "Expiring",
  "month": "Month",
  "months": "Months",
  "none": "None",
  "warning": "Warning",
  "since": "Since",
  "contacts_search": {
    "search_within": "Search within",
    "no_contacts_found": "No contacts here. Start building your empire. ",
    "searching_contacts": "Searching contacts"
  },
  "actions": {
    "edit": "Edit",
    "confirm": "Confirm",
    "confirming": "Confirming",
    "remove": "Remove",
    "removing": "Removing",
    "cancel": "Cancel",
    "canceling": "Canceling",
    "delete": "Delete",
    "deleting": "Deleting",
    "deleted": "Deleted",
    "close": "Close",
    "closing": "Closing",
    "change": "change",
    "changes": "Changes",
    "save": "Save",
    "saving": "Saving",
    "saving_change": "Saving Change",
    "saved": "Saved",
    "create": "Create",
    "creating": "Creating",
    "clone": "Clone",
    "cloning": "Cloning",
    "reset": "Reset",
    "next": "Next",
    "update": "Update",
    "updating": "Updating",
    "updated": "Updated",
    "upload": "Upload",
    "uploading": "Uploading",
    "add": "Add",
    "adding": "Adding",
    "search": "Search",
    "searching": "Searching",
    "see_more": "See more",
    "see_less": "See less",
    "download": "Download",
    "downloading": "Downloading",
    "downloaded": "Downloaded",
    "save_changes": "Save changes",
    "saving_changes": "Saving changes",
    "copy": "Copy",
    "copying": "Copying",
    "move": "Move",
    "moving": "Moving",
    "sync": "Sync",
    "syncing": "Syncing",
    "optimizing": "Optimizing",
    "processing": "Processing",
    "add_users": "Add Users",
    "back": "Back",
    "view_all": "View all",
    "edit_all": "Edit all",
    "read": "Read",
    "write": "Write",
    "import": "Import",
    "importing": "Importing",
    "view_more": "View More",
    "reauthencticate": "Re-authenticate",
    "click_view": "Click here to view",
    "proceed":"Proceed",
    "proceeding": "Proceeding",
    "invite_users": "Invite users",
    "send": "Send",
    "sending": "Sending",
    "load_more_items": "Load more items",
  },
  "tooltip": {
    "recipient_activities": "Recipient activities",
  },
  "roles": {
    "admin": "Admin",
    "owner": "Owner",
    "administrators": "Administrator",
    "bi_analyst": "BI analyst",
    "content_publisher": "Content Publisher",
    "normal_user": "Normal User",
    "starter_licence": "Starter",
  },
  "loading": {
    "loading": "Loading",
    "streams": "Loading streams",
    "collections": "Loading collections",
    "stream": "Loading stream",
    "collection": "Loading collection",
    "asset": "Loading asset",
    "assets": "Loading assets",
    "conversations": "Loading conversations",
    "more_items": "Loading more items",
    "users": "Loading users",
    "analytics": "Loading analytics",
    "mapping": "Loading Mappings",
    "sources": "Loading Sources",
    "fetching": "Fetching",
    "layout": "Loading layouts",
    "pages": "Loading Pages",
    "fetching_content": "Fetching your content",
    "contacts": "Loading contacts",
    "image": "Loading Image",
    "links": "Loading links",
    "fields": "Loading fields",
    "recipients": "Loading recipients",
    "report": "Loading report",
    "lists": "Loading lists",
    "section" : "Loading section",
    "user_groups": "Loading user groups",
    "thumbnail": "Loading thumbnail"
  },

  "time": {
    "time": "Time",
    "hour": "hour",
    "hours": "hours",
    "minute": "minute",
    "minutes": "minutes",
    "second": "second",
    "seconds": "seconds",
    "today": "Today",
    "yesterday": "Yesterday",
    "older": "Older"
  },

  "assets_headers": {
    "file_name": "File Name",
    "details": "Details",
    "streams": "Streams",
    "views": "Views",
    "shares": "Shares",
    "downloads": "Downloads",
    "time_spent": "Time Spent"
  },

  "conversations_filter": {
    "all_activity": "All Activity",
    "email_opened": "Email Opened",
    "link_clicked": "Link Clicked",
    "asset_downloaded": "Asset Downloaded",
    "asset_viewed": "Asset Viewed",
    "asset_added": "Asset Added",
    "asset_reshared": "Asset Reshared",
    "collection_reshared": "Collection Reshared",
    "collection_viewed": "Collection Viewed",
    "lead_captured": "Lead Captured"
  },

  "timeline": {
    "link_clicked": "Clicked on your content {createdDate}, {time}",
    "email_open": "Opened Email on {createdDate}, {time}",
    "asset_download": "Downloaded {assetName} on {createdDate}, {time}",
    "asset_viewed": "Viewed the Asset {assetName} on {createdDate}, {time}",
    "assets_reshared": "Reshared the Asset {assetName} on {createdDate}, {time}",
    "collection_reshared": "Reshared the Collection {name} on {createdDate}, {time}",
    "collection_viewed": "Viewed the Collection {name} on {createdDate}, {time}",
    "lead_captured": "Captured Lead on {createdDate}, {time}",
    "asset_added": "Added {assetName} asset on {createdDate}, {time}"
  },
  "sliders": {
    "add_to_collection": {
      "title": "collection",
      "sub_text": "personalized content storyboards",
      "create_new_collection": "Create New Collection",
      "placeholder": "Enter a collection name",
      "description": "Please enter a name for the new collection you'd like to create. The selected assets will automatically be added to this new collection.",
      "toast": {
        "success": "{collectionName} Created With this Asset."
      }
    },
    "contacts": {
      "conversation_activity": "Conversation Activity",
      "shared_by": "Shared {date} by",
      "actions": {
        "view_conversation": "View Conversation",
        "update_contact": "Update Contact",
        "delete_contact": "Delete Contact"
      },
      "loading": {
        "shares": "Loading shares",
        "details": "Loading details",
      },
      "update_contact": {
        "create_new_contact": "Create New Contact",
        "first_name": "First Name",
        "last_name": "Last Name",
        "email": "Email",
        "title": "Title",
        "company": "Company",
        "work_phone": "Work Phone",
        "mobile_phone": "Mobile Phone",
        "mobile": "Mobile",
        "social_profiles": "Social Profiles",
        "facebook": "Facebook",
        "linkedin": "Linkedin",
        "twitter": "Twitter",
        "instagram": "Instagram",
        "new_organization" : "Add {company} as a new organization",
        "actions": {
          "add_profile_image": "Add Profile <br /> Image"
        },
        "placeholders": {
          "title": "Enter title",
          "first_name": "Enter first name",
          "last_name": "Enter last name",
          "email": "Enter email",
          "company": "Enter company name",
          "work_phone": "Enter work phone",
          "mobile": "Enter mobile number",
          "facebook": "Enter facebook profile",
          "linkedin": "Enter linkedin id",
          "twitter": "Enter twitter handle",
          "instagram": "Enter instagram id"
        }
      },
      "tooltip": {
        "session_excluded": "This session has been excluded.",
        "not_viewed": "Not yet viewed",
        "not_downloaded": "Not yet downloaded",
        "no_reshares": "No reshares",
        "last_viewed": "Last viewed",
        "last_viewed_on": "Last viewed on",
        "last_downloaded_on": "Last downloaded on",
        "last_clicked_on": "Last clicked on a link on",
        "opened_email_last_on": "Opened email last on",
        "reshared": "Reshared {count} times, last on",
        "nda_signed_on": "NDA signed on"
      },
      "no_access": {
        "title": "No access",
        "message": "You do not have access to view this contact."
      },
      "empty_message": {
        "title": "No visibility yet! This space is reserved for contact level analytics.",
        "message": "Share some material and we’ll show you how {firstName} engaged with your content.",
        "action_button": "Share now"
      }
    }
  },
  "tiny_mce":{
    "insert_widget": {
      "asset_table": {
        "title": "Asset Table",
        "description": "Insert the assets as a table of attachments"
      },
      "view_collection_button": {
        "title": "View Collection Button",
        "actions": {
          "view_content": "View Content"
        },
        "description": "The collection you add will appear as a CTA button."
      },
      "link": {
        "title": "Link",
        "description": "Insert a link to your collection / assets as text.",
        "actions": {
          "view_content": "View Content",
          "view_more": "Click here to view more"
        }
      },
      "signature": {
        "title": "Your signature",
        "description": "Upload your signature here and seal the deal."
      }
    },
    "insert_placeholder":{
      "first_name": "First Name",
      "last_name": "Last Name",
      "company" : "Company",
      "signature": "Signature",
    }
  },
  "error_messages":{
    "source_destination_same": "Source & destination cannot be the same",
    "something_went_wrong": "Oops!! Something went wrong. Please try after some time.",
  },
  "toast": {
    "deleted": "Deleted successfully"
  },
  "account_maintenance": {
    "description" : "Sorry we’ve ghosted you! We’ll be under construction from 7/1 - 7/7 to make some exciting updates to your favorite platform. Don’t miss us too much!"
  }
}